import React from 'react';
import { HStack, Badge, IconButton, Tooltip } from '@chakra-ui/react';
import { CloseIcon } from '@chakra-ui/icons';

export default function FilterChip({ label, value, onClear, maxWidth = '200px' }) {
  const content = typeof value === 'string' ? value : JSON.stringify(value);
  return (
    <HStack spacing={1} bg="gray.50" border="1px solid" borderColor="gray.200" borderRadius="full" pl={3} pr={1} py={1} maxW={maxWidth}>
      <Badge colorScheme="gray" variant="subtle" borderRadius="full">{label}</Badge>
      <Tooltip label={content} hasArrow isDisabled={!content || content.length < 16}>
        <Badge colorScheme="brand" variant="solid" borderRadius="full" maxW={maxWidth} textOverflow="ellipsis" overflow="hidden" whiteSpace="nowrap">
          {content || '—'}
        </Badge>
      </Tooltip>
      {onClear && (
        <IconButton aria-label={`Clear ${label}`} icon={<CloseIcon boxSize={2.5} />} size="xs" variant="ghost" onClick={onClear} />
      )}
    </HStack>
  );
}


